import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section id="hero" className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden" data-id="element-123">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-124">
        <img src="https://cdn.magicpatterns.com/uploads/fcKF7LPYXApRrE1fBXihTe/Banner_Mati_Sales_Page_2.png" alt="Pareja mirando el atardecer en la playa" className="w-full h-full object-cover object-[center_70%]" data-id="element-125" />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal-dark/70 via-charcoal-dark/50 to-charcoal-dark z-10" data-id="element-126"></div>
      </div>

      <div className="relative z-20 max-w-5xl mx-auto px-6 text-center" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-128">
          <h1 className="text-3xl md:text-5xl lg:text-7xl font-heading font-bold text-offwhite leading-tight mb-6 md:mb-8" data-id="element-129">
            Hay una versión de vos que sabe exactamente{' '}
            <span className="text-sand" data-id="element-130">quién es</span>,{' '}
            <span className="text-sand" data-id="element-131">qué quiere</span> y cómo sostenerse.
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-132">
          <p className="text-lg md:text-2xl text-offwhite-dim font-light mb-8 md:mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-133">
            RESET es el camino de vuelta. 7 días para recuperar coherencia real:
            cuerpo fuerte, mente calma y vida con dirección.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} data-id="element-134">
          <Button href="https://wa.link/we351n" size="lg" withArrow className="shadow-2xl shadow-sand/20" data-id="element-135">
            WhatsApp: "RESET"
          </Button>
          <p className="mt-6 text-sm text-offwhite-dim/60 font-medium tracking-wide uppercase" data-id="element-136">
            Acompañamiento 1 a 1 • Cupos Limitados
          </p>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20" animate={{
      y: [0, 10, 0]
    }} transition={{
      repeat: Infinity,
      duration: 2
    }} data-id="element-137">
        <a href="#lead" className="text-offwhite-dim/50 hover:text-sand transition-colors" aria-label="Scroll down" data-id="element-138">
          <div className="w-[1px] h-16 bg-gradient-to-b from-transparent via-sand to-transparent mx-auto" data-id="element-139"></div>
        </a>
      </motion.div>
    </section>;
}